<template>
  <div class="imgsort-list">
    <div class="page-filter">
      <div class="condition-wrap">
        <span class="condition-label">提现时间</span>
        <el-date-picker
          v-model="date"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div>
      <div class="condition-wrap">
        <span class="condition-label">提现手机号</span>
        <el-input v-model="telephone" placeholder="请输入手机号"></el-input>
      </div>
      <div class="condition-wrap">
        <span class="condition-label">类型</span>
        <el-select v-model="authorType">
          <el-option label="全部" value=""></el-option>
          <el-option label="个人" value="1"></el-option>
          <el-option label="企业" value="2"></el-option>
        </el-select>
      </div>
      <div class="condition-wrap">
        <span class="condition-label">状态</span>
        <el-select v-model="status">
          <el-option label="全部" value=""></el-option>
          <el-option label="待审核" value="0"></el-option>
          <el-option label="审核通过" value="1"></el-option>
          <el-option label="审核失败" value="2"></el-option>
        </el-select>
      </div>
      <div class="condition-wrap">
        <el-button type="primary" @click="getList">筛选</el-button>
      </div>
    </div>
    <el-table :data="tableData" style="width: 100%" size="middle" border stripe>
      <el-table-column prop="telephone" label="提现手机号" align="center"></el-table-column>
      <el-table-column prop="realName" label="认证姓名" align="center"></el-table-column>
      <el-table-column prop="createTime" label="提现时间" align="center"></el-table-column>
      <el-table-column prop="money" label="申请金额（￥）" align="center"></el-table-column>
      <el-table-column prop="realMoney" label="实际提现金额（￥）" align="center"></el-table-column>
      <el-table-column label="提现状态" align="center">
        <template slot-scope="scope">
          <el-link
            v-if="scope.row.status == 2"
            @click="searchFailReason(scope.row.remark)"
            type="primary"
            >{{ statusObj[scope.row.status] }}</el-link
          >
          <span v-else>{{ statusObj[scope.row.status] }}</span>
        </template>
      </el-table-column>
      <el-table-column label="失败理由" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.remark || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="类型" align="center">
        <template slot-scope="scope">
          {{ scope.row.authorType == 1 ? '个人' : '企业' }}
        </template>
      </el-table-column>
      <el-table-column label="提现方式" align="center">
        <template slot-scope="scope">
          {{ scope.row.cashType == 1 ? '支付宝' : '微信' }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="300">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.status == '0' && scope.row.authorType == 2"
            size="small"
            type="primary"
            @click="showAuditModal(scope.row.id)"
            >审核</el-button
          >
          <el-button
            v-if="scope.row.authorType == 2"
            size="small"
            type="primary"
            @click="searchInfo(scope.row.id)"
            >查看发票物流</el-button
          >
          <el-button
            v-if="scope.row.authorType == 2 && scope.row.status === 1"
            size="small"
            type="primary"
            @click="payConfirm(scope.row.id)"
            >支付</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="site-page">
      <el-pagination
        background
        :page-count="totalPage"
        :current-page="pageNum"
        @current-change="getList"
        layout="prev, pager, next, jumper"
      ></el-pagination>
    </div>
    <AuditDialog ref="auditDialog" @fail="fail" @success="success" />
    <!-- <AuditDialog
      title="支付审核"
      subTitle="请输入打款失败原因"
      cancelText="打款失败"
      confirmText="打款成功"
      ref="statusDialog"
      @fail="statusFail"
      @success="statusSuccess"
    >
    </AuditDialog> -->
    <el-dialog
      width="500px"
      title="发票物流"
      :visible.sync="searchInfoVisible"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form v-if="searchInfoVisible" :model="companyCashForm" size="small" label-width="130px">
        <el-form-item label="企业名称：">
          {{ companyCashForm.authorInfo }}
        </el-form-item>
        <el-form-item label="到账支付宝：">
          {{ companyCashForm.alipayAccount }}
        </el-form-item>
        <el-form-item label="提现金额："> ￥{{ companyCashForm.money }} </el-form-item>
        <el-form-item label="剩余可提现金额：">
          ￥{{ companyCashForm.ableCashTotal }}
        </el-form-item>
        <el-form-item label="发票物流公司：">
          {{ companyCashForm.expressName }}
        </el-form-item>
        <el-form-item label="发票物流单号：">
          {{ companyCashForm.expressNo }}
        </el-form-item>
        <el-form-item label="发票照片：">
          <img
            @click="searchBig(companyCashForm.billUrl)"
            style="width:200px;height:200px;cursor:pointer;"
            :src="companyCashForm.billUrl + '?x-oss-process=image/resize,w_200'"
            alt=""
          />
          <!-- <MyUpload disabled info="" :imgKey.sync="companyCashForm.billKey" :url="companyCashForm.billUrl" /> -->
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="searchInfoVisible = false">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="发票图片"
      :visible.sync="designImgVisible"
      width="600px"
    >
      <div v-if="designImgVisible">
        <img :src="currentDesignImgUrl" style="width: 100%;" alt="" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import API from '../lib/API'
import AuditDialog from '../components/common/AuditDialog.vue'
import MyUpload from '../components/common/MyUpload.vue'
export default {
  name: 'MyIPOrder',
  components: {
    AuditDialog,
    MyUpload
  },
  data() {
    return {
      tableData: [],
      pageNum: 1,
      totalPage: 0,
      tagName: '',
      withdrawVisiable: false,
      withdrawPrice: '',
      withdraiedVisiable: false,
      searchInfoVisible: false,
      designImgVisible: false,
      currentDesignImgUrl: '',
      companyCashForm: {
        expressName: '',
        expressNo: '',
        billUrl: '',
        bullKey: ''
      },
      statusObj: {
        0: '待审核',
        1: '审核通过',
        2: '审核失败',
        3: '打款成功',
        4: '打款失败'
      },
      telephone: '',
      status: '',
      authorType: '',
      id: '',
      date: []
    }
  },
  created() {
    this.getList()
  },
  methods: {
    searchBig(url) {
      this.designImgVisible = true
      this.currentDesignImgUrl = url
    },
    showAuditModal(id) {
      this.id = id
      this.$refs.auditDialog.showModal()
    },
    searchFailReason(reason) {
      this.$alert(reason, '失败原因')
    },
    hideAuditModal() {
      this.$refs.auditDialog.hideModal()
    },
    showStatusModal(id) {
      this.id = id
      this.$refs.statusDialog.showModal()
    },
    hideStatusModal() {
      this.$refs.statusDialog.hideModal()
    },
    searchInfo(id) {
      this.id = id
      new API(this).POST({
        url: '/cashOutRecord/expressInfo',
        params: {
          id: this.id
        },
        cb: res => {
          Object.assign(this.companyCashForm, res)
        }
      })
      this.searchInfoVisible = true
    },
    payConfirm(id) {
      this.id = id
      this.$confirm('确认支付前，请确认发票是否已到达，是否确认支付？', '支付确认', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.statusSuccess()
        })
        .catch(action => {})
    },
    auditMethod(status, reason) {
      new API(this).POST({
        url: '/cashOutRecord/checkCashOutRecord',
        params: {
          id: this.id,
          status,
          remark: reason
        },
        cb: res => {
          this.getList()
        }
      })
    },
    statusMethod(status, reason) {
      new API(this).POST({
        url: '/cashOutRecord/payCashOutRecord',
        params: {
          id: this.id,
          status,
          remark: reason
        },
        cb: res => {
          this.getList()
        }
      })
    },
    fail(reason) {
      this.auditMethod(2, reason)
    },
    success() {
      this.auditMethod(1, '')
    },
    statusFail(reason) {
      this.statusMethod(4, reason)
    },
    statusSuccess() {
      this.statusMethod(3, '')
    },
    getList(val) {
      let startTime = ''
      let endTime = ''
      if (this.date && this.date.length > 0) {
        startTime = dayjs(this.date[0]).format('YYYY-MM-DD') + ' 00:00:00'
        endTime = dayjs(this.date[1]).format('YYYY-MM-DD') + ' 23:59:59'
      }
      if (!isNaN(val)) {
        this.pageNum = val
      } else {
        this.pageNum = 1
      }
      new API(this).POST({
        url: '/cashOutRecord/listWithPage',
        params: {
          count: true,
          pageNum: this.pageNum,
          startTime,
          endTime,
          telephone: this.telephone,
          pageSize: 10,
          status: this.status,
          authorType: this.authorType
        },
        cb: res => {
          let { pages, result } = res
          this.totalPage = pages
          this.tableData = result
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.summary {
  display: flex;
  margin: 20px 0;
  .item {
    margin-right: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/WithdrawRecord.vue